import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getCuisines = async () => (await client.get("/cuisines")).data;
export const getCuisine = async (key) => (await client.get(`/cuisines/${key}`)).data;
export const getRecipes = async (params = {}) =>
  (await client.get("/recipes", { params })).data;
export const getRecipe = async (id) => (await client.get(`/recipes/${id}`)).data;
export const createRecipe = async (data) => (await client.post("/recipes", data)).data;
export const updateRecipe = async (id, data) =>
  (await client.put(`/recipes/${id}`, data)).data;
export const deleteRecipe = async (id) => (await client.delete(`/recipes/${id}`)).data;
